export default __webpack_public_path__ + "static/media/BTC-OFF.d03a9e6b.png";